import { review } from "../libs/api-url";
import axios from "@/libs/axios";

/**
 * Review Management Service
 * Handles all freelancer/business profile review admin API calls.
 *
 * API Endpoints:
 * - GET /api/v1/admin/review/list - Get review list
 * - GET /api/v1/admin/review/get - Get single review detail
 * - DELETE /api/v1/admin/review/delete - Soft delete a review
 */
class ReviewService {
  /**
   * @name getList
   * @description Fetches the review list with pagination, search and filters.
   * @param {Object} params - Query parameters (page, limit, search, freelancer_uuid, reviewer_uuid, rating, start_date, end_date)
   * @returns {Promise<Object>} The response data containing the review list.
   */
  static async getList(params = {}) {
    try {
      const response = await axios.get(review.list, { params });
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  /**
   * @name get
   * @description Fetches a single review's full detail by UUID.
   * @param {string} uuid - Review UUID
   * @returns {Promise<Object>} The response data containing the review detail.
   */
  static async get(uuid) {
    try {
      const response = await axios.get(review.get, { params: { uuid } });
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  /**
   * @name deleteReview
   * @description Soft deletes an inappropriate/abusive review.
   * @param {string} uuid - Review UUID
   * @returns {Promise<Object>} The response data.
   */
  static async deleteReview(uuid) {
    try {
      const response = await axios.delete(review.delete, { params: { uuid } });
      return response.data;
    } catch (err) {
      throw err;
    }
  }
}

export { ReviewService };
